<template>
  <div class="wrapper d-inline-block">
    <button type="button" class="btn btn-primary" @click.prevent="open"><i class="fas fa-folder-open"></i></button>
    <input ref="input" class="d-none" type="file" @change="onChange" multiple></input>
  </div>
</template>

<script>
export default {
  props: {
    value: File,
  },

  computed: {
    /**
     * @return {boolean}
     */
    hasValue() {
      return Boolean(this.value);
    }
  },

  methods: {
    /**
     * @return {undefined}
     */
    open() {
      this.$refs.input.click();
    },

    /**
     * @return {undefined}
     */
    onChange() {
      this.$emit('input', this.$refs.input.files);
    },
  },
}
</script>

<style scoped>

</style>
